import React, { memo } from "react";
import styled from "@emotion/styled";
import { AnimatePresence, motion } from "motion/react";
import {
  MDSDotPulseLoader,
  MDSDotPulseLoaderKind,
  MDSDotPulseLoaderSize,
} from "@/mds/components/dot-pulse-loader";
import { SessionStatus } from "../session.types";
import { VirtuosoMessageListProps } from "@virtuoso.dev/message-list";
import {
  SessionItem,
  SessionItemContext,
} from "@/mds/components/sessions/session-item/session-item.utils";

type FooterComponent = VirtuosoMessageListProps<SessionItem, SessionItemContext>["Footer"];

/**
 * Footer for the session list that displays a loading indicator while the session is processing.
 */
export const SessionListFooter: FooterComponent = memo(({ context }) => {
  const isProcessing = context?.status === SessionStatus.Processing;

  return (
    <StatusIndicatorWrapper>
      <AnimatePresence>
        {isProcessing && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <MDSDotPulseLoader
              size={MDSDotPulseLoaderSize.Small}
              kind={MDSDotPulseLoaderKind.Brand}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </StatusIndicatorWrapper>
  );
});

const StatusIndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  margin-left: 14px;
  margin-top: 4px;
`;
